const Badge = ({ children, variant = 'gray', className = '' }) => {
  const variantClasses = {
    green: 'badge-green',
    amber: 'badge-amber',
    gray: 'badge-gray',
    blue: 'bg-blue-100 text-blue-800 px-2 py-0.5 text-xs font-medium rounded',
    red: 'bg-red-100 text-red-800 px-2 py-0.5 text-xs font-medium rounded',
    // Backwards-compatible aliases used across the app
    success: 'badge-green',
    info: 'badge-amber',
    default: 'badge-gray',
    secondary: 'badge-gray',
    // Additional aliases for wiki system
    warning: 'badge-amber',
    danger: 'bg-red-100 text-red-800 px-2 py-0.5 text-xs font-medium rounded',
  }
  
  return (
    <span className={`badge ${variantClasses[variant] || variantClasses.gray} ${className}`}>
      {children}
    </span>
  )
}

export default Badge


